var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 39,
    viewBox: "0 0 58 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 39,
    rx: 8,
    fill: "#E5EFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 9V15C29 15.5304 29.2107 16.0391 29.5858 16.4142C29.9609 16.7893 30.4696 17 31 17H37V27C37 27.5304 36.7893 28.0391 36.4142 28.4142C36.0391 28.7893 35.5304 29 35 29H23C22.4696 29 21.9609 28.7893 21.5858 28.4142C21.2107 28.0391 21 27.5304 21 27V11C21 10.4696 21.2107 9.96086 21.5858 9.58579C21.9609 9.21071 22.4696 9 23 9H29ZM30.5 9.5V15C30.5 15.1326 30.5527 15.2598 30.6464 15.3536C30.7402 15.4473 30.8674 15.5 31 15.5H36.5L30.5 9.5Z",
    fill: "#0060B9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame18);
export default __webpack_public_path__ + "static/media/Frame 18.27314d16539a250a4fe4fe9a32c3ff3e.svg";
export { ForwardRef as ReactComponent };